import React from 'react';
import { useEffect } from 'react';
import { Routes, Route } from "react-router-dom";
import { MsalProvider, useMsal } from '@azure/msal-react';
import './App.css';
import { Home } from './Pages/Home/Home';
import LandingPage from './Pages/LandingPage/LandingPage';
import DataExtractionPage from './Pages/DataExtractionPage/DataExtractionPage';
import TaskListPage from './Pages/TaskListPage/TaskListPage';
import NewTaskPage from './Pages/NewTaskPage/NewTaskPage';
import MyFilesPage from './Pages/MyFilesPage/MyFilesPage';
import UserNotificationsPage from './Pages/UserNotificationsPage/UserNotificationsPage';
import ReportsPage from './Pages/ReportsPage/ReportsPage';
import AdminNotificationsPage from './Pages/AdminNotificationsPage/AdminNotificationsPage';
import APIDocumentationPage from './Pages/ApiDocumentationPage/ApiDocumentationPage';
import AdminSupportPage from './Pages/AdminSupportPage/AdminSupportPage';
import MonthlyRequestsPage from './Pages/AdminSupportPage/MonthlyTiicketsPage';
import DataExtractionQueuePage from './Pages/DataExtractionQueuePage/DataExtractionQueuePage';
import AdminNewsPage from './Pages/AdminNewsPage/AdminNewsPage';
import GeneralConfigurationsPage from './Pages/AdminConfigurations/GeneralConfigurationTabs';
import AllTicketsPage from './Pages/AdminSupportPage/AllTicketsPage';
import LicenseProtectedRoute from './Components/ProtectedRoutes/LicenseProtectedRoutes';
import LicensePage from './Pages/LicensePage/LicensePage';
import TicketDetailsPage from './Pages/AdminSupportPage/TicketDetailsPage';
import LicensePageNoSeat from './Pages/LicensePageNoSeat/LicensePageNoSeat';
import ChatPage from './Pages/ChatPage/ChatPage';
import ChatFilesPage from './Pages/ChatFilesPage/ChatFilesPage';
import ProductCatalogPage from './Pages/ProductsCatalog/ProductCatalog';
import StoreCatalogPage from './Pages/StoresCatalog/StoreCatalog';
import ProductDetailsPage from './Pages/ProductsCatalog/ProductDetails';
import StoreDetailsPage from './Pages/StoresCatalog/StoreDetails';
import SchedulerTaskListPage from './Pages/SchedulerTaskListPage/SchedulerTaskListPage';
import TemplatesListPage from './Pages/TemplatesPage/TemplatesPage';
import NewsPortalPage from './Pages/NewsPortalPage/NewsPortal';
import DashboardAssistantPage from './Pages/DashboardAssistant/DashboardAssistantPage';
import DashboardLibraryPage from './Pages/DashboardAssistant/DashboardLibraryPage';

const Pages = () => {
    const { instance } = useMsal();

    return (
        <Routes>
            <Route path='/' element={<LandingPage />} />
            <Route path="/license" element={<LicensePage />} />
            <Route path="/no-seat-assigned" element={<LicensePageNoSeat />} />

            <Route element={<LicenseProtectedRoute />}>
                <Route exact path='/home' element={ <ChatPage menu="Data" title="Data Chat" /> } />
                <Route path="/data-extraction/*" element={<DataExtractionPage />}>
                    <Route path="" element={<TaskListPage />} />
                    <Route path="new-task" element={<NewTaskPage />} />
                </Route>
                <Route exact path="/welcome" element={<Home />} />
                <Route exact path='/files' element={ <MyFilesPage /> } />
                <Route exact path='/chat-files' element={ <ChatFilesPage /> } />
                <Route exact path='/chat' element={ <ChatPage menu="Data" title="Data Chat" /> } />
                <Route exact path='/docu-chat' element={ <ChatPage menu="Documents" title="Docu Chat" /> } />
                <Route exact path='/notifications' element={ <UserNotificationsPage /> } />
                <Route exact path='/admin-notifications' element={ <AdminNotificationsPage /> } />
                <Route exact path='/admin-news' element={ <AdminNewsPage /> } />
                <Route exact path='/admin-config' element={ <GeneralConfigurationsPage /> } />
                <Route exact path='/dashboards' element={ <ReportsPage /> } />
                <Route exact path='/support' element={ <AdminSupportPage /> } />
                <Route exact path="/support/ticket" element={<TicketDetailsPage />} />
                <Route path="/support/ticket/:id" element={<TicketDetailsPage />} />
                <Route exact path='/support/open-requests' element={ <AllTicketsPage /> } />
                <Route exact path='/support/monthly-requests' element={ <MonthlyRequestsPage /> } />
                <Route exact path='/docs/api/v1' element={ <APIDocumentationPage /> } />
                <Route exact path='/product-catalog' element={ <ProductCatalogPage /> } />
                <Route path='/product-catalog/:id' element={ <ProductDetailsPage /> } />
                <Route exact path='/store-catalog' element={ <StoreCatalogPage /> } />
                <Route path='/store-catalog/:id' element={ <StoreDetailsPage /> } />
                <Route exact path='/scheduled-tasks' element={ <SchedulerTaskListPage /> } />
                <Route exact path='/extraction-templates' element={ <TemplatesListPage /> } />
                <Route exact path='/news' element={ <NewsPortalPage /> } />
                <Route exact path='/dashboard-assistant' element={ <DashboardAssistantPage /> } />
                <Route exact path='/dashboard-library' element={ <DashboardLibraryPage /> } />
            </Route>
        </Routes>
    );
};

const App = ({ instance }) => {
    return (
        <MsalProvider instance={instance}>
            <Pages />
        </MsalProvider>
    );
};

export default App;
